import React from 'react';
import { Router } from 'react-router';
import routes from './routes';

const createRouterShell = (store, history) => {
  const RouterShell = () => (
    <Router history={history} routes={routes(store)} />);

  return RouterShell;
};

export default createRouterShell;



// WEBPACK FOOTER //
// ./src/RouterShell.js